import React from "react";
//#region types
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { ExternalCompanyHoldingsMoreActionProps } from "models/propTypes/externalCompanyHoldingsPropTypes";
//#endregion
//#region components
import { MoreActions } from "components/common";
import useExternalCompanyHoldingsSnoozeAction from "components/externalCompanyHoldings/actions/useExternalCompanyHoldingsSnoozeAction";
//#endregion

const ExternalCompanyHoldingsMoreActions: React.FC<ExternalCompanyHoldingsMoreActionProps> = (props) => {
  const snoozeAction = useExternalCompanyHoldingsSnoozeAction(0, props.markAsDoneHandler!);

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];
    actions.push(snoozeAction);
    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} disableSuccessMessages={props.disableSuccessMessages} />;
};

export default ExternalCompanyHoldingsMoreActions;
